module.exports = __webpack_public_path__ + "static/logo-light-mobil-e8190cbfd1569cfcbf1753d98c84d784.png";